import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { trackPixelEvent } from '../hooks/useMetaPixel';
import { brand, offer } from '../data/content';
interface CtaButtonProps {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'compact';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  href?: string;
  className?: string;
}
const base = 'group inline-flex items-center justify-center gap-3 rounded-2xl text-center font-extrabold uppercase leading-tight tracking-tight transition-[transform,background-color,box-shadow,color,border-color] duration-150 ease-out focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-pink-300 active:translate-y-px';
const sizes: Record<NonNullable<CtaButtonProps['size']>, string> = {
  sm: 'px-4 py-2.5 text-xs',
  md: 'px-6 py-3.5 text-sm',
  lg: 'px-8 py-4 text-base md:text-lg',
  xl: 'px-8 py-5 text-lg md:text-2xl'
};
const variants: Record<NonNullable<CtaButtonProps['variant']>, string> = {
  primary: 'bg-pink-600 text-white shadow-lg shadow-pink-600/30 hover:bg-pink-900',
  secondary: 'border-2 border-pink-600 bg-transparent text-pink-700 hover:border-pink-900 hover:text-pink-900',
  compact: 'bg-pink-600 text-white hover:bg-pink-900'
};
export function CtaButton({
  children,
  variant = 'primary',
  size = 'lg',
  href = '#inversion',
  className = ''
}: CtaButtonProps) {
  const isCheckout = href.startsWith('http');
  const handleClick = () => {
    if (!isCheckout) return;
    trackPixelEvent('InitiateCheckout', {
      content_name: brand.name,
      value: offer.pixelValue,
      currency: offer.currencyCode
    });
  };
  return <a href={href} onClick={handleClick} className={`${base} ${sizes[size]} ${variants[variant]} ${className}`} data-id="element-42" data-mp="1jzbvc13zjnw">
      <span data-id="element-43" data-mp="6k55uyuupi95">{children}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-200 ease-out group-hover:translate-x-1 md:h-6 md:w-6" aria-hidden="true" data-id="element-44" data-mp="bhdt3duuwch9" />
    </a>;
}